module.exports = __webpack_public_path__ + "img/engineer-full.01e3227d.png";